import { api } from '../../api/client';
import type { RegistrationRole } from '../registration/model';

export type YandexOAuthFlow = 'login' | 'registration' | 'request';

export interface PendingYandexRegistration {
  email: string;
  first_name: string;
  last_name: string;
  display_name: string;
  role: RegistrationRole;
  flow: YandexOAuthFlow;
}

export function startYandexOAuth(role: RegistrationRole, flow: YandexOAuthFlow): void {
  const params = new URLSearchParams({ role, flow });
  window.location.assign(`/api/auth/yandex/start/?${params.toString()}`);
}

export function loadPendingYandexRegistration(): Promise<PendingYandexRegistration> {
  return api<PendingYandexRegistration>('/api/auth/yandex/pending/');
}

export function hashQuery(): URLSearchParams {
  const queryIndex = window.location.hash.indexOf('?');
  return new URLSearchParams(queryIndex >= 0 ? window.location.hash.slice(queryIndex + 1) : '');
}

export function yandexOAuthErrorMessage(code: string | null): string {
  if (!code) return '';
  if (code === 'access_denied') return 'Вы отменили вход через Яндекс.';
  if (code === 'email_exists') return 'Аккаунт с этой почтой уже есть. Войдите по паролю, чтобы безопасно привязать Яндекс ID.';
  if (code === 'account_disabled') return 'Этот аккаунт LOVO отключён. Обратитесь в поддержку.';
  if (code === 'role_missing') return 'В аккаунте нет выбранного профиля заказчика или перевозчика.';
  if (code === 'not_configured') return 'Вход через Яндекс пока не настроен.';
  if (code === 'invalid_state' || code === 'expired') return 'Сессия входа через Яндекс устарела. Попробуйте ещё раз.';
  return 'Не удалось войти через Яндекс. Попробуйте ещё раз.';
}
